import { createSelector } from 'reselect';
import {
  getProductId,
  getSectionProduct,
} from '@productConfig/selectors/getProduct';
import getMenu from '@core/reducers/menu/selectors/getMenu';

const getProductNutritionLabes = createSelector(
  getMenu,
  getSectionProduct,
  getProductId,
  (menu, sec, productId) => {
    const section = menu?.sections?.find(s => s.id === sec?.id);

    if (section) {
      const product = section.products.find(p => p.id === productId);
      if (product?.infoLabels) {
        return product?.infoLabels;
      }
    }

    return [];
  },
);

export default getProductNutritionLabes;
